import axios from 'src/utils/axios';

type DVOpts = { actingOnMemberId?: number | null };

export interface PQSection {
  id: string;
  name: string;
  status: 'not_started' | 'incomplete' | 'complete';
  answeredCount: number;
  totalCount: number;
  lastAnsweredAt: string | null;
}

export const getProfileSections = (opts: DVOpts = {}): Promise<PQSection[]> => {
  const url = opts.actingOnMemberId
    ? `data-vault/members/${opts.actingOnMemberId}/profile-survey/sections/`
    : 'profile-survey/sections/';
  return axios.get<{ sections: PQSection[] }>(url).then((r) => r.data.sections);
};
